module.exports = "../dist/frontend/icons/ui/appStore.svg?11efc45770da4bbabb61be3423a25e61";